import React from "react";
import IOText from "../ReUableComponents/ImageOntext";
import CBanner from "../Assessts/Images/CBanner.png";
import "../Assessts/Styles/ContactUs.scss";
const ContactUs = () => {
  
    return (
        <>
            <div className="Single_Banner mt-2">
                <IOText Image={CBanner} Alt="EMpower" Text={<div className="Text-MainDiv" >
                    <div></div>
                    <div >Contact Us</div>
                    <div className="mt-2 Text-Content" >
                        <span style={{ color: "#F7D670" }}> Home  </span>   &gt;     Contact Us
                    </div>
                </div>} />
            </div>
            <div className="Web-MainHeading mt-3">Contact Us – Customer Assistance</div>

            <div className="dflex gap-3 JCCenter ContactUs-Details mb-4">
                <div className="dflex gap-3 alignitems flexd-column">
                    <p>India Scholarships</p>
                    <span className="Web-SubHeading">indiascholarships@northsouth.org</span>
                </div>
                <div className="dflex gap-3 alignitems flexd-column">
                    <p>NCP</p>
                    <span className="Web-SubHeading">ncp@northsouth.org</span>
                </div>
                
            </div>
            {/*  */}
        </>
    )
}
export default ContactUs;